import React from 'react';
import '../Styles/FAQ.css';
import questions from "../../Data/Questions"
import Question from "./Question"
import Headers from "./Headers"

const FAQ = () => {
    return (
      <div className="faq-section">
        <Headers heading={"Frequently asked questions"} name="FAQ"/>
        {questions.map((question, index) => (
           <Question 
                key={index}
                question={question.question} 
                answer={question.answer}
                isLast={index === questions.length - 1}
            />
        ))}
      </div>
    );
  };
  

export default FAQ;
